import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { DeleteAccountDialogComponent } from './delete-account-dialog.component';

@NgModule({
  declarations: [DeleteAccountDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule],
  exports: [DeleteAccountDialogComponent],
  entryComponents: [DeleteAccountDialogComponent],
})
export class DeleteAccountDialogModule {}
